<template>
  <div>
    <ActionAdd />
  </div>
</template>

<script>
import ActionAdd from "./ActionAdd.vue";

export default {
  components: {
    ActionAdd,
  },

  data() {
    return {};
  },
};
</script>
